import type { FetchZoneDefinitionListParams } from 'Services/ProductManagement/Features/ZoneDefinition/types'
import { useGetZoneDefinitionsQuery } from 'Services/ProductManagement/Features/ZoneDefinition/zoneDefinitionApi'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_ZONE_DEFINITION_PARAMETER_KEY = 'selectedZoneDefinition'

function useZoneDefinitionsWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [params, setParams] = useState<FetchZoneDefinitionListParams>({
    filter: searchParams.get('filter') ?? undefined,
    search_text: searchParams.get('search_text') ?? undefined,
    sort_by: searchParams.get('sort_by') ?? 'productCode',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT
  })

  const { data: zoneDefinitions = [], isLoading, isFetching } = useGetZoneDefinitionsQuery(params)

  const selectedProductQueryParam =
    searchParams.get(SELECTED_ZONE_DEFINITION_PARAMETER_KEY) ?? undefined
  const [selectedZoneDefinitionId, setSelectedZoneDefinitionId] =
    useState(selectedProductQueryParam)

  const setQueryParams = () => {
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    selectedZoneDefinitionId &&
      searchParams.set(SELECTED_ZONE_DEFINITION_PARAMETER_KEY, selectedZoneDefinitionId)

    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [params])

  useEffect(() => {
    if (selectedZoneDefinitionId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_ZONE_DEFINITION_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedZoneDefinitionId])

  return {
    zoneDefinitions,
    isZoneDefinitionsLoading: isLoading || isFetching,
    total_results: zoneDefinitions.length,
    params,
    setParams,
    selectedZoneDefinitionId,
    setSelectedZoneDefinitionId
  }
}

export default useZoneDefinitionsWithParams
